import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { ProjectService } from "../../../services/project.service";
import { NotificationService } from "../../../services/notification.service";
// import { group } from "console";

interface DialogData {
  email: string;
}

@Component({
  selector: "app-modal-govt-land-mutation",
  templateUrl: "./govtLandMutation.modal.component.html",
  styleUrls: ["./modal.component.css"],
})
export class ModalGovtLandMutation implements OnInit {
  govt_land_mutation_completion_form: FormGroup;
  id: any;

  villageData: any;
  showWarning: boolean = false;
  remainingLand: any;
  constructor(
    public dialogRef: MatDialogRef<ModalGovtLandMutation>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,
    private projectService: ProjectService,
    private notification: NotificationService
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.projectService.villageID.subscribe((res) => {
      this.id = res;
    });
    this.projectService.retrieveVillageData(this.id).subscribe((res) => {
      this.villageData = res;
      this.remainingLand =
        this.villageData.govt_possession_notification -
        this.villageData.govt_mutation_notification;

      if (this.remainingLand > 0) {
        this.showWarning = true;
      }
    });
    this.govt_land_mutation_completion_form = this.fb.group({
      govt_mutation: new FormControl(null, Validators.required),
      govt_mutation_remark: new FormControl(null, Validators.required),
    });
  }

  onSubmit() {
    const data = this.govt_land_mutation_completion_form.value;
    this.projectService.updateCompletionStatus(this.id, data).subscribe(
      (res) => {
        console.log(res);
        this.notification.showNotification(
          "top",
          "right",
          "success",
          "Data Posted successfully"
        );
      },
      (err) => {
        this.notification.showNotification("top", "right", "error", err.status);
      }
    );

    this.dialogRef.close();
  }
}
